export function useIsMobile() {
    var isMobile = window.innerWidth < 768;
    return isMobile;
}
